import { sanitizeLabelMarkup } from './sanitizeLabelMarkup';

const sanitizePriceStack = (stack) =>
	Array.isArray(stack)
		? stack.map((item) =>
				item && typeof item === 'object'
					? { ...item, label: sanitizeLabelMarkup(item.label) }
					: item
		  )
		: stack;

/**
 * @param {object} pricing raw vehicle pricing
 * @param {boolean} [shouldSanitizeLabels=false] when true, drops tag tokens the
 * DOM would reject from each price item's label (US2051450). Off by default so
 * callers outside the pricing-detail render path keep the previous behaviour.
 */
export const pricingMap = (pricing = {}, shouldSanitizeLabels = false) => {
	// TODO: remove mapping here (and in ws-detailed-pricing) and update wsm-pricing-display to use lowercase version once GVM databus is retired
	const { dprice, dPrice, eprice, ePrice, ...restPricing } = pricing;
	const mapStack = shouldSanitizeLabels
		? sanitizePriceStack
		: (stack) => stack;

	return {
		dPrice: mapStack(dPrice || dprice),
		ePrice: mapStack(ePrice || eprice),
		...restPricing
	};
};
